import "./resultatRemExpress.css";
import { useState, useContext, useEffect } from "react";
import { FaCalculator, FaCog, FaIdBadge, FaPrint, FaBuilding, FaChartLine, FaRobot } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import { applyFormat } from "components/ui/ui-helpers";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DetailTNSPageModal from "pages/audit complet/résultat/detail/rémuneration/detailTNSPager";
import DetailSalariePageModal from "pages/audit complet/résultat/detail/rémuneration/detailSalariePager";
import RemExpressRemunerationTns from "components/app/AuditRemuneration/Resultat/RemExpressRemunerationTns";
import RemExpressRemunerationSalarie from "components/app/AuditRemuneration/Resultat/RemExpressRemunerationSalarie";
import RemExpressResAvtIS from "components/app/AuditRemuneration/Resultat/RemExpressResAvtIS";
import RemExpressRevenus from "components/app/AuditRemuneration/Resultat/RemExpressRevenus";
import CompactFinancialCard, { FINANCIAL_THEMES, CompactFinancialContainer } from "components/app/AuditRemuneration/Resultat/CompactFinancialCard";
import { SyntheseCalculWord } from "components/app/Api/Rapport/ApiRapport";
// import DetailTNSPageModal from "./detail/rémuneration/detailTNSPager";
// import DetailSalariePageModal from "./detail/rémuneration/detailSalariePager";
// import DropDown from "components/ui/controls/drop-down/drop-down";
// import { AuditCompletWord } from "components/app/Api/Rapport/ApiRapport";

const ResultatRemExpressPage = (props) => {
  let { ClientConjoint } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalDetail, setModalDetail] = useState(false);
  const Periode = context.state["OptiRemPeriodeActuelle" + ClientConjoint] === undefined ? undefined : context.state["OptiRemPeriodeActuelle" + ClientConjoint][0];
  const Prenom = context.state.Prenom;
  const [circularWidth, setCircularWidth] = useState("0px");

  useEffect(() => {
    context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "", ResultatTNS, "");
  }, []);

  let cotProductiveRetraiteObligatoire = 0;

  cotProductiveRetraiteObligatoire =
    ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.RetraiteObligatoire === undefined
      ? 0
      : ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.RetraiteObligatoire;

  let cotProductiveRetraiteFacultative = 0;
  cotProductiveRetraiteFacultative = isNaN(
    Number(ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.RetraiteFacultative) +
      Number(ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.TotalPEEProductif) +
      Number(ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.TotalPERCOProductif)
  )
    ? 0
    : ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.RetraiteFacultative +
      ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.TotalPEEProductif +
      ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.TotalPERCOProductif;

  return (
    <>
      <Column fill>
        <Row>
          <Column fill style={{ minWidth: "500px", maxWidth: "820px" }}>
            <div className="resultat-header-card">
              <div className="resultat-header-card-content">
                <div className="resultat-header-card-icon-container">
                  <FaBuilding className="resultat-header-card-icon" />
                </div>
                <span className="resultat-header-card-title">Enveloppe entreprise</span>
              </div>
              <div className="resultat-header-card-value">{applyFormat(context.state.RemExpressCoutEntreprise, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
            {context.state.Statut === "TNS Article 62" || context.state.Statut === "TNS individuel" ? (
              <RemExpressRemunerationTns Prenom={Prenom} />
            ) : (
              <RemExpressRemunerationSalarie Prenom={Prenom} />
            )}
            {(context.state.Statut !== "TNS individuel" || context.state.ModeExercice === "IS") && <RemExpressResAvtIS ClientConjoint={ClientConjoint} Periode={Periode} Prenom={Prenom} />}
            <RemExpressRevenus />
            <div className="resultat-header-card">
              <div className="resultat-header-card-content">
                <div className="resultat-header-card-icon-container">
                  <FaCalculator className="resultat-header-card-icon" />
                </div>
                <span className="resultat-header-card-title-flex">Revenu disponible</span>
              </div>
              <div className="resultat-header-card-with-input">
                <TextField
                  value={context.state.RemExpressRevDispo}
                  onChange={(e) => context.handleCalculRemExpress("revenu_dispo", "RemExpressRevDispo", ResultatTNS, e)}
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                  style={{
                    height: "28px",
                    width: "110px",
                    padding: "0 8px",
                    backgroundColor: "#e0f2fe",
                    border: "1px solid #b3e5fc",
                    borderRadius: "6px",
                    textAlign: "right",
                    fontSize: "12px",
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    fontWeight: "400",
                    color: "#0277bd",
                    transition: "all 0.2s ease"
                  }}
                />
              </div>
            </div>
            <div className="resultat-header-card">
              <div className="resultat-header-card-content">
                <div className="resultat-header-card-icon-container">
                  <FaChartLine className="resultat-header-card-icon" />
                </div>
                <span className="resultat-header-card-title">Cotisations productives en matière de retraite</span>
              </div>
              <div className="resultat-header-card-value">
                {applyFormat(cotProductiveRetraiteObligatoire + cotProductiveRetraiteFacultative, "uint", { thousands: " ", decimal: ",", unit: " €" })}
              </div>
            </div>
          </Column>
          <Column fill style={{ maxWidth: "600px" }}>
            {/* Cartes d'action compactes - Disposition 2x2 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                padding: "12px",
                background: "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.98) 100%)",
                borderRadius: "12px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                border: "1px solid rgba(255,255,255,0.9)",
              }}
            >
              {/* Première ligne - 2 boutons */}
              <div style={{ display: "flex", gap: "8px" }}>
                {/* Carte Détails - Version compacte */}
                <div
                  onClick={() => setModalDetail(true)}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                    borderRadius: "8px",
                    padding: "12px",
                    color: "white",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(59, 130, 246, 0.3)",
                    flex: 1,
                    minHeight: "60px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 15px rgba(59, 130, 246, 0.4)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(59, 130, 246, 0.3)";
                  }}
                >
                  {/* Mini graphiques décoratifs */}
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "8px",
                      opacity: 0.2,
                      display: "flex",
                      gap: "2px",
                      alignItems: "end",
                    }}
                  >
                    <div style={{ width: "2px", height: "6px", background: "white", borderRadius: "1px" }}></div>
                    <div style={{ width: "2px", height: "10px", background: "white", borderRadius: "1px" }}></div>
                    <div style={{ width: "2px", height: "4px", background: "white", borderRadius: "1px" }}></div>
                  </div>

                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaCalculator style={{ fontSize: "14px" }} />
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "2px",
                      }}
                    >
                      Détail des calculs {Prenom}
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        opacity: 0.8,
                        fontWeight: "400",
                      }}
                    >
                      Charges sociales et impôt
                    </div>
                  </div>
                </div>

                {/* Carte Synthèse - Version compacte */}
                <div
                  onClick={() => {
                    SyntheseCalculWord(context.state, ResultatTNS.state).then((res) => {});
                  }}
                  style={{
                    background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                    borderRadius: "8px",
                    padding: "12px",
                    color: "white",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(5, 150, 105, 0.3)",
                    flex: 1,
                    minHeight: "60px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 15px rgba(5, 150, 105, 0.4)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(5, 150, 105, 0.3)";
                  }}
                >
                  {/* Mini document décoratif */}
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "8px",
                      opacity: 0.2,
                      width: "12px",
                      height: "15px",
                      background: "white",
                      borderRadius: "2px",
                    }}
                  >
                    <div style={{ width: "8px", height: "1px", background: "#059669", margin: "3px 2px 1px 2px" }}></div>
                    <div style={{ width: "6px", height: "1px", background: "#059669", margin: "1px 2px" }}></div>
                  </div>

                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaPrint style={{ fontSize: "14px" }} />
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "2px",
                      }}
                    >
                      Synthèse des calculs
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        opacity: 0.8,
                        fontWeight: "400",
                      }}
                    >
                      Editer un rapport Word
                    </div>
                  </div>
                </div>
              </div>

              {/* Deuxième ligne - 2 boutons */}
              <div style={{ display: "flex", gap: "8px" }}>
                {/* Carte Simulation - Version compacte */}
                <div
                  onClick={() => props.GoToSimulation()}
                  style={{
                    background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
                    borderRadius: "8px",
                    padding: "12px",
                    color: "white",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(124, 58, 237, 0.3)",
                    flex: 1,
                    minHeight: "60px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 15px rgba(124, 58, 237, 0.4)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(124, 58, 237, 0.3)";
                  }}
                >
                  {/* Mini paramètres décoratifs */}
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "8px",
                      opacity: 0.2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                      <div style={{ width: "6px", height: "1px", background: "white" }}></div>
                      <div style={{ width: "3px", height: "3px", background: "white", borderRadius: "50%" }}></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                      <div style={{ width: "4px", height: "1px", background: "white" }}></div>
                      <div style={{ width: "3px", height: "3px", background: "white", borderRadius: "50%" }}></div>
                    </div>
                  </div>

                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaCog style={{ fontSize: "14px" }} />
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "2px",
                      }}
                    >
                      Simulations
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        opacity: 0.8,
                        fontWeight: "400",
                      }}
                    >
                      Générer des scénarios d'optimisation
                    </div>
                  </div>
                </div>

              </div>
            </div>
            {/* Cotisations productives en matière de retraite - Carte blanche détaillée */}
            <div
              style={{
                background: "#ffffff",
                borderRadius: "12px",
                padding: "16px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
                border: "1px solid rgba(0,0,0,0.06)",
                margin: "16px 0",
              }}
            >
              {/* Titre de section */}
              <div
                style={{
                  fontSize: "12px",
                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                  fontWeight: 600,
                  color: "#1f2937",
                  margin: "0 0 8px 0",
                  letterSpacing: "-0.02em",
                  borderBottom: "1px solid rgba(0,0,0,0.1)",
                  paddingBottom: "8px",
                }}
              >
                Cotisations productives en matière de retraite
              </div>
              {/* Cartes financières compactes */}
              <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "12px" }}>
                <CompactFinancialCard
                  title="Cotisations de retraite obligatoire"
                  value={applyFormat(cotProductiveRetraiteObligatoire, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  icon={<FaChartLine style={{ color: "#2563eb" }} />}
                  accentColor="#2563eb"
                />

                <CompactFinancialCard
                  title="Cotisations de retraite facultative"
                  value={applyFormat(cotProductiveRetraiteFacultative, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  icon={<FaChartLine style={{ color: "#7c3aed" }} />}
                  accentColor="#7c3aed"
                />
              </div>
            </div>
          </Column>
        </Row>
      </Column>
      {/* MODAL DETAIL CLIENT */}
      <Modal
        width="80%"
        height="82%"
        title="Details"
        icon={<FaIdBadge />}
        visible={modalDetail}
        onClose={() => {
          setModalDetail(false);
        }}
      >
        {context.state.Statut === "TNS Article 62" || context.state.Statut === "TNS individuel" ? (
          <DetailTNSPageModal
            AccessRemExpress={true}
            ClientConjoint=""
            Outil=""
            Prenom={Prenom}
            Caisse={context.state.Caisse}
            DetailImpot={ResultatTNS.state.DetailImpot}
            GraphPerp={ResultatTNS.state.DetailImpot?.GraphPerp}
            InfosPerp={ResultatTNS.state.DetailImpot?.InfosPerp}
            GraphDisponible={ResultatTNS.state.RemExpressRemuneration?.GraphDisponible}
            InfosDisponible={ResultatTNS.state.RemExpressRemuneration?.Rapport?.DispoDepaMadelin}
            DetailCotisations={ResultatTNS.state.RemExpressRemuneration?.DetailCotisations}
            DetailAssiette={ResultatTNS.state.RemExpressRemuneration?.DetailAssiette}
            DetailCSG={ResultatTNS.state.RemExpressRemuneration?.DetailCSG}
            TotalChargesSociales={ResultatTNS.state.RemExpressRemuneration?.TotalChargesSociales}
            DetailAssietteClient={ResultatTNS.state.RemExpressRemuneration?.DetailAssiette}
            visible={modalDetail}
            onClose={() => {
              setModalDetail(false);
            }}
          />
        ) : (
          <DetailSalariePageModal
            AccessRemExpress={true}
            Outil=""
            ClientConjoint=""
            Prenom={Prenom}
            DetailImpot={ResultatTNS.state.DetailImpot}
            GraphPerp={ResultatTNS.state.DetailImpot?.GraphPerp}
            InfosPerp={ResultatTNS.state.DetailImpot?.InfosPerp}
             InfosDisponible={ResultatTNS.state.RemExpressRemuneration?.Rapport?.InfosDisponible}
            DetailFicheDePaie={ResultatTNS.state.RemExpressRemuneration?.DetailFicheDePaie}
            DetailAssietteClient={ResultatTNS.state.RemExpressRemuneration?.DetailFicheDePaie}
            GraphDisponible={ResultatTNS.state.RemExpressRemuneration?.GraphDisponible}
            visible={modalDetail}
            onClose={() => {
              setModalDetail(false);
            }}
          />
        )}
      </Modal>
    </>
  );
};

export default ResultatRemExpressPage;
